import { SlidingStatBar } from 'app/layouts/stats/sliding';
import { getRelativeTimeStampRange } from 'app/shared/utils/date';
import { useContactService } from 'hooks/users/contact';
import { useMailActionService } from 'hooks/mailaction';
import { useMailLogService } from 'hooks/maillog';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { RelativeStatCard } from 'app/shared/cards/stat/relative';
import styles from '../view.module.css';

export const ContactViewStatBar = () => {
  const { id } = useParams();

  const { fetchContact } = useContactService();
  const { fetchMailLogs } = useMailLogService();
  const { fetchMailActions } = useMailActionService();

  const [stats, setStats] = useState([
    {
      label: 'Emails sent',
      main_value: 0,
      current_value: 0,
      previous_value: 0
    },
    {
      label: 'Emails opened',
      main_value: 0,
      current_value: 0,
      previous_value: 0
    },
    {
      label: 'Links clicked',
      main_value: 0,
      current_value: 0,
      previous_value: 0
    }
  ]);

  useEffect(() => {
    const { this_month, last_month } = getRelativeTimeStampRange();
    fetchContact(id).then(async ({ email }) => {
      if (!email) return;

      const [
        { size: emails_all_time },
        { size: emails_this_month },
        { size: emails_last_month },
        { size: opens_all_time },
        { size: opens_this_month },
        { size: opens_last_month },
        { size: clicks_all_time },
        { size: clicks_this_month },
        { size: clicks_last_month }
      ] = await Promise.all([
        fetchMailLogs({
          query_string: `class=campaign&recipient=${email}&count=1`
        }),
        fetchMailLogs({
          query_string: `time_stamp=${this_month.start}~${this_month.end}&class=campaign&recipient=${email}&count=1`
        }),
        fetchMailLogs({
          query_string: `time_stamp=${last_month.start}~${last_month.end}&class=campaign&recipient=${email}&count=1`
        }),
        fetchMailActions({
          query_string: `action=opened&recipient_email=${email}&count=1`
        }),
        fetchMailActions({
          query_string: `time_stamp=${this_month.start}~${this_month.end}&action=opened&recipient_email=${email}&count=1`
        }),
        fetchMailActions({
          query_string: `time_stamp=${last_month.start}~${last_month.end}&action=opened&recipient_email=${email}&count=1`
        }),
        fetchMailActions({
          query_string: `action=clicked_link&recipient_email=${email}&count=1`
        }),
        fetchMailActions({
          query_string: `time_stamp=${this_month.start}~${this_month.end}&action=clicked_link&recipient_email=${email}&count=1`
        }),
        fetchMailActions({
          query_string: `time_stamp=${last_month.start}~${last_month.end}&action=clicked_link&recipient_email=${email}&count=1`
        })
      ]);

      setStats([
        {
          label: 'Emails sent',
          main_value: emails_all_time,
          current_value: emails_this_month,
          previous_value: emails_last_month
        },
        {
          label: 'Emails opened',
          main_value: opens_all_time,
          current_value: opens_this_month,
          previous_value: opens_last_month
        },
        {
          label: 'Links clicked',
          main_value: clicks_all_time,
          current_value: clicks_this_month,
          previous_value: clicks_last_month
        }
      ]);
    });
  }, [id]);

  return (
    <SlidingStatBar className={styles.slidingStatBar}>
      {stats.map((stat, index) => (
        <RelativeStatCard
          key={index}
          title={stat.label}
          main_value={stat.main_value}
          current_value={stat.current_value}
          previous_value={stat.previous_value}
          period={'month'}
        />
      ))}
    </SlidingStatBar>
  );
};
